import axios from './withAxios'
import {
  ConfiguracaoEmpresa,
  ConfiguracaoFiscalAcao
} from '../interfaces/configuracaoFiscal'

export const buscarConfiguracaoEmpresa = async (): Promise<ConfiguracaoEmpresa> => {
  const resposta = await axios.get('/configuracaoFiscal/empresa', {
    params: { avoidFeedbackMessage: true }
  })
  return resposta.data as ConfiguracaoEmpresa
}

export const salvarConfiguracaoEmpresa = async (
  empresa: ConfiguracaoEmpresa
): Promise<ConfiguracaoEmpresa> => {
  const resposta = await axios.put('/configuracaoFiscal/empresa', empresa)
  return resposta.data as ConfiguracaoEmpresa
}

export const buscarConfiguracaoAcoes = async (): Promise<ConfiguracaoFiscalAcao[]> => {
  const resposta = await axios.get('/configuracaoFiscal/acoes', {
    params: { avoidFeedbackMessage: true }
  })
  return (resposta.data || []) as ConfiguracaoFiscalAcao[]
}

export const salvarConfiguracaoAcao = async (
  acao: ConfiguracaoFiscalAcao
): Promise<ConfiguracaoFiscalAcao> => {
  const resposta = await axios.put('/configuracaoFiscal/acoes', acao)
  return resposta.data as ConfiguracaoFiscalAcao
}
